module.exports = __webpack_public_path__ + "assets/img/right.df50b38b.svg";